<div *ngIf="_currentPage">

	<div class="sb-page-title-container margin-bottom-large">
		<div class="grid-x">
			<div class="cell small-1 bold">Section:</div>
			<div class="cell auto">
				{{currentSection?.name }}
			</div>
		</div>
		<div class="grid-x" *ngIf="!isEditingTitle">
			<div class="cell small-1 bold">Page:</div>
			<div class="cell auto" [ngClass]="{'sb-page-placeholder': _currentPage.subtitle === ''}">{{_currentPage.subtitle === '' ? pageTitlePlaceholder : _currentPage.subtitle}}</div>
			<div class="cell shrink">
				<button class="minor-margin-right" (click)="isEditingTitle=true" title="Edit" attr.aria-label="Edit Page Title '{{_currentPage.subtitle}}'">
					<svg-icon icon="icon-pencil" class="small dark gray" aria-hidden="true"></svg-icon>
				</button>
			</div>
		</div>
		<div class="grid-x" *ngIf="isEditingTitle">
			<div class="cell small-1 bold">Page:</div>
			<div class="cell auto">
				<input type="text" id="PageName" class="no-margin" placeholder="Enter Page Title" [(ngModel)]="_currentPage.subtitle" [ngClass]="{'is-invalid-input' : pageNameNonUnique}">
				<span class="form-error" [ngClass]="{'is-visible' : pageNameNonUnique}">Page title must be unique within a form.</span>
			</div>
			<div class="cell shrink full-height">
				<button class="minor-margin-left" (click)="isEditingTitle = false" title="Save Page Title" attr.aria-label="Save Page Title">
					<svg-icon icon="icon-save" class="tiny" aria-hidden="true"></svg-icon>
				</button>
			</div>
		</div>
	</div>


	<div *ngIf="_currentPage?.pageType === pageType.Input || _currentPage?.pageType === pageType.Summary; else summaryTemplate" class="sb-page-row-container margin-bottom"
		 [ngClass]="{'no-instruction': hasDesignRows}" id="pageRowDropList" cdkDropList [cdkDropListEnterPredicate]="canDropRow" (cdkDropListDropped)="onRowDrop($event)" [cdkDropListData]="_currentPage.questions">
		<div class="grid-x">
			<div class="cell large-2 medium-2 small-3 text-align-right padding-right-small">
				Add New Row
			</div>
			<div class="cell large-2 medium-2 small-3 padding-right-small">
				<select [(ngModel)]="rowSize" class="minor-margin-right">
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
				</select>
			</div>
			<div class="cell large-8 medium-8 small-6 padding-left-small">
				<button class="button" (click)="addRow()">Add Row</button>
			</div>
		</div>
		<div *ngFor="let questionGroup of _currentPage.questions; let i = index; let last = last" class="relative" cdkDrag>
			<div class="outer-handle vertical right middle dark-gray" [ngClass]="{ 'active': i == activeQuestionGroup }">
				<button (click)="deleteQuestionGroup($event, _currentPage, i)"><svg-icon icon="icon-trash" class="small cursor-pointer"></svg-icon></button>
				<button class="cursor-grab"><svg-icon icon="icon-up-down-drag" class="small"></svg-icon></button>
			</div>
			<div class="question-row"
				 cdkDropList
				 [cdkDropListEnterPredicate]="canDropQuestion"
				 [id]="'rowDropList-' + questionGroup._rowId"
				 [cdkDropListData]="questionGroup"
				 [cdkDropListId]="'rowDropList-' + questionGroup._rowId"
				 [cdkDropListConnectedTo]="getConnectedRowListIds(questionGroup._rowId)"
				 (cdkDropListDropped)="onQuestionDrop($event, i)"
				 [ngClass]="{'no-margin': last}">
				<ng-container *ngFor="let question of questionGroup; let j = index">
					<div class="question-cell"
						 cdkDrag
						 (click)="questionCellClick(question)"
						 [ngClass]="{'active': currentlyEditingQuestion === question}"
						 [ngStyle]="{'flex-grow': question.flexGrow || 1}">
						<ng-template #componentRef="componentLoaderRef" dynamic-component-loader [componentName]="question.type" [componentData]="question" [isEdit]="true"></ng-template>
						<div class="outer-handle bottom center" *ngIf="currentlyEditingQuestion === question">
							<button class="cursor-grab" *ngIf="currentlyEditingQuestionHasType"><svg-icon class="tiny dark-gray" icon="icon-arrows"></svg-icon></button>
							<button (click)="flexGrow(question, false)" [disabled]="disabledQuestionSize(question)"><svg-icon icon="icon-minus" class="cursor-pointer tiny dark-gray" [ngClass]="{'disabled' : disabledQuestionSize(question)}"></svg-icon></button>
							<button (click)="flexGrow(question, true)"><svg-icon icon="icon-plus" class="cursor-pointer tiny dark-gray"></svg-icon></button>
							<button (click)="modifyQuestion($event, question, componentRef)" *ngIf="currentlyEditingQuestionHasType && isEditableQuestionType(question)"><svg-icon icon="icon-widget" class="cursor-pointer tiny dark-gray"></svg-icon></button>
							<button (click)="deleteQuestion(questionGroup, j, i)"><svg-icon icon="icon-trash" class="cursor-pointer tiny dark-gray"></svg-icon></button>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	SUMMARY 
	<ng-template #summaryTemplate>
		<div class="sb-page-row-container margin-bottom" [ngClass]="{'no-instruction': hasDesignRows}">
			<div *ngFor="let questionGroup of _currentPage.questions; let i = index" class="relative">
				<div class="question-row">
					<ng-container *ngFor="let question of questionGroup; let j = index">
						<div class="question-cell" [ngClass]="{'active': currentlyEditingQuestion === question}" [ngStyle]="{'flex-grow': question.flexGrow || 1}">
							<div (click)="questionCellClick(question)">
								<ng-template #summaryComponentRef="componentLoaderRef" dynamic-component-loader [componentName]="question.type" [componentData]="question" [isEdit]="true"></ng-template>
							</div>
							<div class="outer-handle bottom center" *ngIf="currentlyEditingQuestion === question">
								<button (click)="modifyQuestion($event, question, summaryComponentRef)" *ngIf="question.type !== 'summary'">
									<svg-icon icon="icon-widget" class="cursor-pointer tiny"></svg-icon>
								</button>
								<button (click)="deleteQuestion(questionGroup, j)">
									<svg-icon icon="icon-trash" class="cursor-pointer tiny"></svg-icon>
								</button>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-template>
	<state-builder-page-buttons [(template)]="activeTemplate" [(state)]="selectedState" [(page)]="_currentPage" (showRulesEvent)="bubbleShowRules($event)"></state-builder-page-buttons>
</div>
